import BannerPng from '../../assets/images/banner.png';
import styles from './Banner.module.css';

const Banner = () => {
  return (
    <section className={styles.banner}>
      <img
        src={BannerPng}
        alt="Баннер"
        className={styles.bannerImage}
      />
    </section>
  );
};

export default Banner;
